export default __webpack_public_path__ + "images/models/4c0483e3b78d7944cff0bbb373576a0d.glb";